import React from 'react';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import DateTimePicker from 'react-datetime-picker';

import FieldCity from '../../common/FieldCity';
import FieldState from '../../common/FieldState';
import FieldCountry from '../../common/FieldCountry';
import FieldController from '../../../controller/FieldController';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';
import Display from '../../../util/Display';

class ScoreCondition extends React.Component {

  constructor(props) {
    super(props);
    const fields = props.fields;
    this.fieldList = [];
    for(let i = 0; i < fields.length; i++) {
      this.fieldList.push({ id: fields[i].id, value: fields[i].fieldKey,
        type: fields[i].field_type, label: fields[i].label_name });
    }
    const conditions = [];
    this.value = { field: '', condition: '', conditions, text: '', fOpt: '', select: '', from: '', to: '', andor: false  , score:0 , type:0};
    const filters = this.getConditions(props.value);
    this.state = { filters };
    this.props.onConditionChanged(filters);
    this.options = [{label:"add", value:1},{label:"substract", value:2},]
  }

  UNSAFE_componentWillReceiveProps(props) {
    const fields = props.fields;
    this.fieldList = [];
    for(let i = 0; i < fields.length; i++) {
      this.fieldList.push({ id: fields[i].id, value: fields[i].fieldKey,
        type: fields[i].field_type, label: fields[i].label_name });
    }
    const filters = this.getConditions(props.value);
    this.setState({ ...this.state, filters });
    this.props.onConditionChanged(filters);
    this.isComponentUpdate = true;
  }

  getConditions = value => 
    value.map(value => {
      const field = this.fieldList.find(field => field.value === value.field);
      if(field === undefined) return { ...value };
      const conditions = FieldController.getConditions(field.type);
      const condition = conditions.find(condition => condition.value === value.condition);
      const fOpt = this.getOptionField(field.type, value.condition);
      const options = this.getOptions(fOpt, field.value, value.value);
      const andor = value.andor ? value.andor : false;
      const score = value.score ? value.score : 0;
      const type = value.type ? value.type : 0;
      value = value.value;
      let from = null, to = null;
      if((field.type === Const.Decimal || field.type === Const.Number) && value) {
        from = value.split(Const.Opt)[0];
        to = value.split(Const.Opt)[1];
      }
      return { field, condition, conditions, value, ...fOpt, ...options, andor, from, to , score , type};
    });

  getOptionField = (type, condition) => {
    const isText = FieldController.showTextFilter(type, condition);
    const isDate = type === Const.Date || type === Const.DateTime;
    const isNumber = type === Const.Decimal || type === Const.Number;
    const isFrom = FieldController.showDateFrom(type, condition);
    const isTo = FieldController.showDateTo(type, condition);
    const isCity = FieldController.showCity(type, condition);
    const isState = FieldController.showState(type, condition);
    const isCountry = FieldController.showCountry(type, condition);
    const isSelect = FieldController.showSelect(type, condition);
    return { isText, isDate, isNumber, isFrom, isTo, isCity, isState, isCountry, isSelect };
  }

  getOptions = (fOpt, field, value) => {
    if(!value) value = '';
    let select = '', options = [], from = null, to = null;
    if(fOpt.isCity) {
      options = FieldController.getOptions({ field_type: Const.City });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isState) {
      options = FieldController.getOptions({ field_type: Const.State });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isCountry) {
      options = FieldController.getOptions({ field_type: Const.Country });
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isSelect) {
      options = FieldController.getOptions(this.props.model.fields[field]);
      select = options.filter(option => value.includes(`~${option.value}~`));
    } else if(fOpt.isFrom || fOpt.isTo) {
      if(value !== '') {
        const dates = value.split(Const.Opt);
        from = Util.serverStringDateTimeToDate(dates[0]);
        to = Util.serverStringDateTimeToDate(dates[1]);
      }
    }
    return { select, options, from, to};
  }

  add = () => this.setState({ ...this.state,filters:[...this.state.filters, {...this.value}]});
  delete = index => {
    let filters = [ ...this.state.filters ];
    filters = filters.filter((_, i) => i !== index);
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [ ...filters ] });
  }
  fieldChange = (i, field) => {
    const filters = [ ...this.state.filters ];
    const conditions = FieldController.getConditions( field !== null ? field.type : '');
    filters[i] = { ...this.value, field: field, conditions };
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [ ...filters ] });
  }
  conChange = (i, con) => {
    const filters = [ ...this.state.filters ];
    const fOpt = this.getOptionField(filters[i].field.type, con ? con.value : '');
    const options = this.getOptions(fOpt, filters[i].field.value, filters[i].value);
    filters[i] = { ...filters[i], condition: con, ...fOpt, ...options, andor: false };
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [ ...filters ] });
  }
  onSelect = (i, select) => {
    const value = select === null ? '' : Array.isArray(select) ? 
    `~${select.map(val => val.value).join('~')}~` : `~${select.value}~`;
    const filters = [ ...this.state.filters ];
    filters[i] = { ...filters[i], select: select, value };
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [ ...filters ] });
  }
  handleDateChange = (i, source, date) => {
    const filters = [ ...this.state.filters ];
    let value = '';
    const from = filters[i].from;
    const to = filters[i].to;
    if(source === 'from' && date !== null && to !== null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}${Util.dateToServerDateTime(to)}`;
    } else if(source === 'from' && date !== null && to === null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}`;
    } else if(source === 'from' && date === null && to !== null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}${Util.dateToServerDateTime(to)}`;
    } else if(source === 'to' && from !== null && date !== null) {
      value = `${Util.dateToServerDateTime(from)}${Const.Opt}${Util.dateToServerDateTime(date)}`;
    } else if(source === 'to' && from !== null && date === null) {
      value = `${Util.dateToServerDateTime(from)}${Const.Opt}`;
    } else if(source === 'to' && from === null && date !== null) {
      value = `${Const.Opt}${Util.dateToServerDateTime(date)}`;
    }

    if(source === 'from') filters[i] = { ...filters[i], value, from: date };
    else filters[i] = { ...filters[i], value, to: date };
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [ ...filters ] });
  }
  handleNumberChange = (i, source, number) => {
    const filters = [ ...this.state.filters ];
    filters[i][source] = number;
    filters[i].value = filters[i].from + Const.Opt + filters[i].to;
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [ ...filters ] });
  }
  textChanged = (i, value) => {
    const filters = [ ...this.state.filters ];
    filters[i].value = value;
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [ ...filters ] });
  }
  scoreAndAddSubtactChanged = (i, name, value) => {
    const filters = [...this.state.filters];
    if (name === 'type') {
      filters[i][name] = this.options.find(option => option.value === value); 
    } else {
      filters[i][name] = value;
    }
    this.props.onConditionChanged(filters);
    this.setState({ filters });
  };
  
  

  onCondition = (i, andor) => {
    const filters = [ ...this.state.filters ];
    filters[i].andor = andor;
    this.props.onConditionChanged(filters);
    this.setState({ ...this.state, filters: [ ...filters ] });
  }

  render() {
    return this.state.filters.map((filter, i) =>
      <div key={`condition_${i}`} className="col-md-12 condition-select-div">
        <div className="condition-select col-md-3">
          <Select value={filter.field} className="mr-sm-2"
            onChange={ selected => this.fieldChange(i, selected) }
            options={this.fieldList} isSearchable={true} isClearable={true} placeholder = "select fields"/>
        </div>
        <div className="condition-select col-md-3">
          <Select value={filter.condition} 
            onChange={ selected => this.conChange(i, selected) }
            options={filter.conditions} isSearchable={true} isClearable={true} placeholder = "select operator"/>
        </div>
        <div className="condition-select col-md-4 value-float">
          { filter.isText ?
            <FormControl type="text" placeholder="Value" value={filter.value}
              onChange={ event => this.textChanged(i, event.target.value) } className='col-md-3' />
            : null
          }
          { filter.isDate && filter.isFrom ?
            <DateTimePicker value={filter.from} format="dd-MM-y" 
              onChange={ date => this.handleDateChange(i, 'from', date)}/>
            : null
          }
          { filter.isDate && filter.isTo ?
            <DateTimePicker value={filter.to} format="dd-MM-y" 
              onChange={ date => this.handleDateChange(i, 'to', date)} className='col-md-3'/>
            : null
          }
          { filter.isNumber && filter.isFrom ?
            <FormControl type="number" placeholder="From" value={filter.from}
              onChange={ event => this.handleNumberChange(i, 'from', event.target.value) } className='col-md-3'/>
            : null
          }
          { filter.isNumber && filter.isTo ?
            <FormControl type="number" placeholder="To" value={filter.to}
              onChange={ event => this.handleNumberChange(i, 'to', event.target.value) } className='col-md-3'/>
            : null
          }
          { filter.isSelect ?
            <Select value={filter.select} options={filter.options}
              onChange={ selected => this.onSelect(i, selected) } 
              isSearchable={true} isClearable={true} isMulti={true}
              className="col-md-8" />
            : null
          }
          { filter.isCity ?
            <FieldCity defaultValue={filter.select} isMulti={true}
              onCitySelected={ selected => this.onSelect(i, selected) } />
            : null
          }
          { filter.isState ? 
            <FieldState defaultValue={filter.select} isMulti={true}
              onStateSelected={ selected => this.onSelect(i, selected) } /> 
            : null
          }
          { filter.isCountry ? 
            <FieldCountry defaultValue={filter.select} isMulti={true}
              onSelected={ selected => this.onSelect(i, selected) } />
              : null
          }
              {/* add / subtract select field */}
         <Select name="type" value={this.options.find(option => option.value === filter.type)} options={this.options} onChange={(selected) =>
           this.scoreAndAddSubtactChanged(i, 'type', selected ? selected.value : null) } 
            isSearchable={true}  className="col-md-5"/>

            {/* score text fields */}
          <FormControl type="number" name="score" placeholder="Score" value={filter.score} 
            onChange={(e) => this.scoreAndAddSubtactChanged(i, 'score', e.target.value)}  className="col-md-4"/>
            { Display.MultiAction(i, this.add, this.delete ) }

          { false && (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
            && filter.select && filter.select.length > 1 &&
            <div>
              <label>Inner Condition</label>
              <Form.Check type="radio">
                <Form.Check.Input type="radio" checked={filter.andor}
                  onChange={() => this.onCondition(i, true)} />
                <Form.Check.Label>AND</Form.Check.Label>
              </Form.Check>
              <Form.Check type="radio">
                <Form.Check.Input type="radio" checked={!filter.andor}
                  onChange={() => this.onCondition(i, false)} />
                <Form.Check.Label>OR</Form.Check.Label>
              </Form.Check>
            </div>
          }
        </div>
      </div>
    );
  }
}
export default ScoreCondition;